import React, { Fragment } from 'react'
import Img1 from "../images/logo-2.png"
import Img2 from "../images/birria-imge.png"
import Img3 from "../images/favorites-deal-1.jpg"
import Img4 from "../images/favorites-deal-2.jpg"
import Img5 from "../images/favorites-deal-3.jpg"
import Img6 from "../images/favorites-deal-4.jpg"
import Img7 from "../images/favorites-deal-5.jpg"
import Img8 from "../images/favorites-deal-6.jpg"
import Img9 from "../images/favorites-deal-7.jpg"
import Img10 from "../images/birria-sm.png"
import Img11 from "../images/heart.png"
import Img12 from "../images/firria-block-image-1.png"
import Img13 from "../images/firria-block-image-2.png"
import Img14 from "../images/firria-block-image-3.png"
import Img15 from "../images/firria-block-image-4.png"
import Img16 from "../images/firria-block-image-5.png"
import Img17 from "../images/firria-block-image-6.png"
import Img18 from "../images/firria-block-image-5.png"
import { Link } from 'react-router-dom'



const MenuTwo = () => {
    return (
        <Fragment>
            <section className="p-[4vmax_3vmax] customBG-5 ">
                <div className=" customBG-4 p-[0_1.5vmax] relative pt-[5vmax] grid grid-cols-[1fr_1.2fr] gap-[4vmax] mt-[5vmax]">
                    <div className="">
                        <h3 className='text-[2vmax]   font-extrabold text-white flex-center customBG-6' >
                            Authentic Birria

                        </h3>
                        <h2 className="relative text-[6vmax] font-[900] text-center uppercase">

                            {/* Stroke Layer */}
                            <span className="absolute inset-0 stroke-text">
                                Big Flavor
                            </span>

                            {/* Fill + Shadow Layer */}
                            <span className="shadow-text">
                                Big Flavor
                            </span>

                        </h2>
                        <h3 className="text-[3.5vmax] font-3 font-[500] text-[#f35d5d] text-center rotate-[-3deg] mt-[-1vmax]">
                            Barbie approved
                        </h3>
                        <br />
                        <p className=' w-[65%] mx-auto text-[1.2vmax] text-[#4b1d16] text-center' >
                            From our birria tacos to ramen bowls,
                            <br />
                            every bite is made with love.
                            <br />
                            Cute, Flavorful & Unapologetically Barbie.
                        </p>
                        <div className='  text-[1.2vmax] text-[#4b1d16] my-[2vmax] text-center' >
                            <button className='bg-[#f35d5d] border-[0.2vmax] border-[#923535] rounded-xl p-[0.5vmax_1vmax] font-bold text-white' >
                                View Our Menu &nbsp;&nbsp;&nbsp;
                                <i className="fa-solid fa-heart text-white "></i>
                            </button>
                        </div>
                        <div className="w-[13vmax] aspect-square bg-white top-[-6.5vmax] left-1/2 -translate-x-1/2 absolute rounded-full flex-center  p-[1vmax] border-[0.5vmax] border-[#F8BDCA] shadow-2xl">
                            <img src={Img1} alt="Logo" className='w-full' />
                        </div>
                    </div>
                    <div className="">
                        <img src={Img2} alt="" />
                    </div>



                </div>
                <br />
                <br />
                <h3 className='text-[2vmax]   font-extrabold text-white flex-center customBG-6' >
                    Popular Picks
                </h3>
                <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr] gap-[1vmax] mt-[5vmax]  mx-auto">
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative">
                        <div className="w-full aspect-[1/0.8] overflow-hidden rounded-xl ">
                            <img src={Img3} alt="" className='w-full object-cover' />
                        </div>
                        <h3 className='text-[1.3vmax] font-bold text-[#4b1d16] text-center mt-[1vmax]' >
                            Birria Torta
                        </h3>
                        <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax] mx-auto my-[0.5vmax]">
                            $ 13.99
                        </div>
                        <p className='text-[1vmax] text-[#4b1d16] text-center mt-[0.5vmax]' >
                            Crispy toasted torta filled with rich birria meat and melted cheese.
                            Served with fresh toppings and flavorful dipping consomé.
                        </p>
                    </div>
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative">
                        <div className="w-full aspect-[1/0.8] overflow-hidden rounded-xl ">
                            <img src={Img4} alt="" className='w-full object-cover' />
                        </div>
                        <h3 className='text-[1.3vmax] font-bold text-[#4b1d16] text-center mt-[1vmax]' >
                            Street Quesabirria Tacos
                        </h3>
                        <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax] mx-auto my-[0.5vmax]">
                            $ 13.99
                        </div>
                        <p className='text-[1vmax] text-[#4b1d16] text-center mt-[0.5vmax]' >
                            Golden tacos stuffed with birria and cheese, grilled to perfection.
                            Served with onions, cilantro, lime, and dipping sauce.
                        </p>
                    </div>
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative">
                        <div className="w-full aspect-[1/0.8] overflow-hidden rounded-xl ">
                            <img src={Img5} alt="" className='w-full object-cover' />
                        </div>
                        <h3 className='text-[1.3vmax] font-bold text-[#4b1d16] text-center mt-[1vmax]' >
                            Street  QuesaBirria Party Tray
                        </h3>
                        <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax] mx-auto my-[0.5vmax]">
                            $ 36.99
                        </div>
                        <p className='text-[1vmax] text-[#4b1d16] text-center mt-[0.5vmax]' >
                            A large tray loaded with flavorful birria tacos for groups.
                            Comes with sides, sauces, and fresh toppings for everyone.
                        </p>
                    </div>
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative">
                        <div className="w-full aspect-[1/0.8] overflow-hidden rounded-xl ">
                            <img src={Img6} alt="" className='w-full object-cover' />
                        </div>
                        <h3 className='text-[1.3vmax] font-bold text-[#4b1d16] text-center mt-[1vmax]' >
                            Queen Ramen Birria
                        </h3>
                        <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax] mx-auto my-[0.5vmax]">
                            $ 19.99
                        </div>
                        <p className='text-[1vmax] text-[#4b1d16] text-center mt-[0.5vmax]' >
                            Rich ramen infused with birria broth, topped with meat and egg.
                            Finished with fresh herbs and a deep, savory flavor.
                        </p>
                    </div>
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative">
                        <div className="w-full aspect-[1/0.8] overflow-hidden rounded-xl ">
                            <img src={Img7} alt="" className='w-full object-cover' />
                        </div>
                        <h3 className='text-[1.3vmax] font-bold text-[#4b1d16] text-center mt-[1vmax]' >
                            Birria Quesadilla
                        </h3>
                        <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax] mx-auto my-[0.5vmax]">
                            $ 14.99
                        </div>
                        <p className='text-[1vmax] text-[#4b1d16] text-center mt-[0.5vmax]' >
                            Grilled quesadilla filled with juicy birria and melted cheese.
                            Crispy outside, soft inside, served with dipping sauce.
                        </p>
                    </div>
                </div>
                <div className="flex flex justify-center gap-[1vmax] mt-[1vmax] items-stretch">
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative w-[calc(40%-1vmax)] flex 
                    justify-between">
                        <div className="w-[30%] aspect-[1/1] h-fit  overflow-hidden rounded-xl ">
                            <img src={Img8} alt="" className='w-full object-cover' />
                        </div>
                        <div className="w-[65%]">

                            <h3 className='text-[1.3vmax] font-bold text-[#4b1d16]  mt-[1vmax]' >
                                Birria Burrito King
                            </h3>
                            <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax]  my-[0.5vmax]">
                                $ 14.99
                            </div>
                            <p className='text-[1vmax] text-[#4b1d16]  mt-[0.5vmax]' >
                                A hearty burrito packed with birria meat, rice, beans, and melted cheese.
                                Wrapped perfectly and served with rich sauces for extra flavor.
                            </p>
                        </div>
                    </div>
                    <div className="p-[1vmax] bg-[#ffd4de] rounded-xl shadow-2xl hover:translate-y-[-1vmax] transition-all duration-300 border-[0.2vmax] border-dashed border-[#f3517745] relative w-[calc(40%-1vmax)] flex 
                    justify-between">
                        <div className="w-[30%] aspect-[1/1] h-fit  overflow-hidden rounded-xl ">
                            <img src={Img9} alt="" className='w-full object-cover' />
                        </div>
                        <div className="w-[65%]">

                            <h3 className='text-[1.3vmax] font-bold text-[#4b1d16]  mt-[1vmax]' >
                                Birria Burger
                            </h3>
                            <div className="w-fit p-[0.5vmax_1vmax] flex-center rounded-full bg-[#f35d5d]  font-extrabold text-white text-[1.2vmax]  my-[0.5vmax]">
                                $ 18.99
                            </div>
                            <p className='text-[1vmax] text-[#4b1d16]  mt-[0.5vmax]' >
                                Juicy burger loaded with birria meat, fresh veggies, and special sauce. Served with fries for a bold and satisfying meal.
                            </p>
                        </div>
                    </div>

                </div>
                <div className=" customBG-4 p-[2vmax] relative pt-[3vmax] grid grid-cols-[1fr] gap-[4vmax] mt-[4vmax]">
                    <div className="grid grid-cols-[1fr_2fr_1fr] items-center">
                        <div className="">
                            <img src={Img10} alt="Logo" className='w-[70%]' />
                        </div>
                        <div>
                            <h2 className="relative text-[4vmax] font-[700] text-center uppercase">

                                {/* Stroke Layer */}
                                <span className="absolute inset-0 stroke-text">
                                    More Birria Bites
                                </span>

                                {/* Fill + Shadow Layer */}
                                <span className="shadow-text">
                                    More Birria Bites
                                </span>

                            </h2>
                            <h3 className="text-[2.8vmax] font-3 font-[500] text-[#f35d5d] text-center rotate-[-3deg] mt-[-1vmax]">
                                Extra Flavor Picks
                            </h3>
                        </div>
                        <div className="flex justify-end">
                            <img src={Img11} alt="Logo" className='w-[60%]' />
                        </div>

                    </div>
                    <div className="flex justify-evenly mt-[-4vmax] mb-[4vmax]">
                        <div className="w-[48%]  p-[1.5vmax]">
                            <h3 className='text-[2vmax]   font-extrabold text-white flex-center customBG-6' >
                                Ramen & Seafood
                            </h3>
                            <br />
                            <div className="grid grid-cols-[0.9fr_2.7fr] p-[1vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img12} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Ramen Birria
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 14.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Warm, rich birria ramen with fresh toppings.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-[0.9fr_2.7fr] p-[1vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img13} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16] capitalize' >
                                            Crawfish & Shrimp
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 18.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Spicy seafood mix packed with bold flavor.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-[0.9fr_2.7fr] p-[1vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img14} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Ramen Birria
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 14.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Classic comfort bowl with savory birria taste.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="w-[48%]  p-[1.5vmax]">
                            <h3 className='text-[1.8vmax]   font-extrabold text-white flex-center customBG-6' >
                                Birria Pizzas
                            </h3>
                            <br />
                            <div className="grid grid-cols-[0.65fr_2.7fr] p-[0.5vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img15} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Pizza Birria Chicken
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 21.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Cheesy pizza topped with flavorful chicken birria.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-[0.65fr_2.7fr] p-[0.5vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img16} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Pizza Birria Fajita
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 22.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Loaded with fajita meat, peppers, and cheese.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-[0.65fr_2.7fr] p-[0.5vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img17} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Pizza Birria Shrimp
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 24.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Seafood twist with juicy shrimp and rich toppings.
                                    </p>
                                </div>
                            </div>
                            <div className="grid grid-cols-[0.65fr_2.7fr] p-[0.5vmax_2vmax] items-center gap-[1.5vmax] bg-[#ffd4de] mx-[2vmax] my-[1vmax] rounded-2xl border-[0.2vmax] border-dashed border-[#f3517745]">
                                <div className=" overflow-hidden aspect-square  ">
                                    <img src={Img18} alt="" className='w-full object-cover' />
                                </div>
                                <div className="">
                                    <div className='flex justify-between items-center' >

                                        <h3 className='text-[1.7vmax] font-bold text-[#4b1d16]' >
                                            Pizza Birria
                                        </h3>
                                        <span className='font-3 text-[2vmax] font-3 text-[#F35177]' >$ 24.99</span>
                                    </div>

                                    <p className='text-[1vmax] text-[#4b1d16]  mt-[-0.5vmax]' >

                                        Signature birria pizza with bold, cheesy flavor.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <br />
                <br />
                <br />
            </section>
              <div className="fixed bottom-[2vmax] left-[50%] -translate-x-1/2 p-[0.5vmax_2vmax] rounded-full customBG-5 shadow-1   hover:translate-y-[-1vmax] border-[0.2vmax] border-[#4b1d16]">
                <Link to={`/`} className=' text-[#4b1d16] text-[1.5vmax] font-extrabold' >
                    Go Back
                </Link>
            </div>
        </Fragment>
    )
}

export default MenuTwo
